<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  #profileContactSideBar {
    @include colors.background-color(interfaceBrandSurfaceLight);
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    padding: utils.in_rem(24px);
    gap: 1rem;

    &.isTodo {
      padding: utils.in_rem(22px) utils.in_rem(24px);
    }

    .profile-card {
      display: flex;
      flex-direction: column;
    }

    .divider {
      width: 100%;
      height: 1px;
      background-color: rgba(28, 28, 28, 0.05);
      flex-shrink: 0;
    }

    .ctas {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(12px);

      .button {
        display: flex;
        justify-content: center;
      }
    }
  }
</style>

<script>
  // Stores
  import { todosModalItemStore } from "../stores";
  import AskAIButton from "./AskAIButton.svelte";
  // Components
  import CandidateCachedOptions from "./CandidateCachedOptions.svelte";
  import ContactInformation from "./ContactInformation.svelte";
  import ProfileCardHeader from "./ProfileCardHeader.svelte";
  import ProfileInformation from "./ProfileInformation.svelte";

  let isTodo = $derived($todosModalItemStore?.toDoId);
  let fromCache = $derived($todosModalItemStore?.fromCache);
  let isDummyCandidateForAiToDo = $derived(
    isTodo && fromCache && !$todosModalItemStore.candidateName
  );
</script>

<section id="profileContactSideBar" class:isTodo>
  {#if isDummyCandidateForAiToDo}
    <CandidateCachedOptions dummyCandidate={true} />
  {:else}
    <div class="profile-card">
      <ProfileCardHeader />
      <ProfileInformation />
    </div>
    {#if !fromCache}
      <div class="divider"></div>
      <ContactInformation />
      <AskAIButton />
    {/if}
  {/if}
</section>
